// covered-by: frontends/carrie/src/ask-v2/pages/__tests__/AskV2ChatPage.test.tsx
import { Heading, Text } from "@radix-ui/themes";
import { useTranslation } from "react-i18next";

import { AskV2SummonBar } from "../transport/SummonBar";
import { AskV2Thread } from "../transport/Thread";
import { useAskV2Transport } from "../transport/useAskV2Transport";

type AskV2ChatPageProps = {
  chatId: string;
};

export function AskV2ChatPage({ chatId }: AskV2ChatPageProps) {
  const { t } = useTranslation("ui");
  const transport = useAskV2Transport();

  return (
    <div
      data-testid="ask-v2-chat-page"
      className="flex min-h-0 w-full flex-1 flex-col items-center gap-6 overflow-y-auto px-6 py-8"
    >
      <header className="flex w-full max-w-2xl flex-col gap-1">
        <Heading as="h2" size="4">
          {t("askV2.pages.chat.title")}
        </Heading>
        <Text as="p" size="2" className="text-puntt-neutral-gray-11">
          {t("askV2.pages.chat.placeholder")}
        </Text>
        <Text as="p" size="1" data-testid="ask-v2-chat-id">
          {chatId}
        </Text>
      </header>
      <AskV2Thread transport={transport} />
      <AskV2SummonBar transport={transport} />
    </div>
  );
}
